import React, { useEffect } from 'react';
import { Link as RouterLink, Navigate, useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, Button, IconButton, Tooltip } from '@mui/material';
import { ArrowBackRounded, ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { TEMPLATES, getTemplate } from '../templates';
import TemplateSite from '../TemplateSite';
import { BrandLogo } from '../brand';
import SiteFooter from '../SiteFooter';
import ChatButton from '../ChatButton';
import { BRAND } from '../../theme';

// Full-page live demo of one template, with a slim bar to move between
// templates or start building with this one.
const TemplateDemo = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const template = getTemplate(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (template) document.title = `${template.name} template · Anainfo`;
    return () => { document.title = 'Anainfo'; };
  }, [template]);

  if (!template) return <Navigate to="/templates" replace />;

  const index = TEMPLATES.indexOf(template);
  const prev = TEMPLATES[(index - 1 + TEMPLATES.length) % TEMPLATES.length];
  const next = TEMPLATES[(index + 1) % TEMPLATES.length];
  const startWithTemplate = () => navigate(`/login?template=${template.slug}`);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: template.colors.bg }}>
      <Box sx={{
        position: 'sticky', top: 0, zIndex: 1100, bgcolor: '#14112b', color: '#fff',
        px: { xs: 1.5, md: 3 }, height: 60, display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 },
      }}>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}><BrandLogo light size={32} /></Box>
        <Button component={RouterLink} to="/templates" startIcon={<ArrowBackRounded />}
          sx={{ color: 'rgba(255,255,255,0.8)', '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' } }}>
          <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>All templates</Box>
          <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>Back</Box>
        </Button>
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, minWidth: 0 }}>
          <Tooltip title={prev.name}>
            <IconButton component={RouterLink} to={`/templates/${prev.slug}`} aria-label={`Previous template: ${prev.name}`} sx={{ color: '#fff' }}>
              <ChevronLeftRounded />
            </IconButton>
          </Tooltip>
          <Box sx={{ textAlign: 'center', minWidth: 0 }}>
            <Typography noWrap sx={{ fontWeight: 600, fontSize: 15 }}>{template.name}</Typography>
            <Typography noWrap sx={{ fontSize: 12, color: 'rgba(255,255,255,0.55)', display: { xs: 'none', sm: 'block' } }}>{template.category}</Typography>
          </Box>
          <Tooltip title={next.name}>
            <IconButton component={RouterLink} to={`/templates/${next.slug}`} aria-label={`Next template: ${next.name}`} sx={{ color: '#fff' }}>
              <ChevronRightRounded />
            </IconButton>
          </Tooltip>
        </Box>
        <Button variant="contained" onClick={startWithTemplate} sx={{ px: { xs: 2, md: 3 }, background: BRAND.gradient, whiteSpace: 'nowrap' }}>
          Use<Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>&nbsp;template</Box>
        </Button>
      </Box>
      <TemplateSite template={template} onAction={startWithTemplate} />
      <SiteFooter />
      <ChatButton />
    </Box>
  );
};

export default TemplateDemo;
